import { Component, createApp, h } from 'vue'

/**
 * Creates an HTML element containing a mounted Vue component
 * @param component The Vue component to render as HTML
 * @returns An HTML element with the component mounted inside
 */
export function componentAsHtml(component: Component): HTMLElement {
  // Create container element
  const container = document.createElement('div')
  
  // Create app with the component
  const app = createApp({
    render: () => h(component)
  })
  
  // Mount the app to the container
  app.mount(container)
  
  return container
}
